import React from "react";

import { Box, Flex } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Information from "../Information";

export const Profissionalizacao = ({ data }) => {
  return data ? (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Profissionalização"
          py="12px"
          mtDivider="5px">
          <Information
            title="Possui curso profissionalizante?"
            information={data.cursoProfissionalizante === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          <Information
            title="Trabalha atualmente?"
            information={data.trabalho === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          <Information
            title="Faz estágio?"
            information={data.estagio === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          <Information
            title="Matriculado no Programa Jovem Aprendiz?"
            information={data.jovemAprendiz === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          {data.nomeEmpresa ? (
            <Information
              title="Nome da empresa?"
              information={
                data.nomeEmpresa.length > 120
                  ? data.nomeEmpresa.slice(0, 120) + "..."
                  : data.nomeEmpresa
              }
              mt="10px"
            />
          ) : (
            ""
          )}
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Profissionalização"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
